module.exports = __webpack_public_path__ + "static/media/01BMCAmuralprep.5f9279e0.webp";